import { Feature } from '@/pinia/feature'
import {
  areaFormat,
  createColorScale,
  createColoredEntitiesDataSource,
  createMeasurementFromName,
  createValueDataSource,
  enabledEntityLevels
} from './common'

const valueDataSource = createValueDataSource('area')
const coloredEntitiesDataSource = createColoredEntitiesDataSource('area')
const measurementFromName = createMeasurementFromName('area')

export const area: Feature = {
  name: 'area',
  enabled: true,
  isRoute: true,
  title: {
    en: 'Overview',
    sv: 'Översikt'
  },
  access: ['FEAT_PORTFOLIO-ANALYSIS-AREA_READER'],
  component: 'DashboardDataSectionFlat',
  props: {
    enabledEntityLevels,
    dataSources: [
      valueDataSource('bta', 0),
      valueDataSource('bra', 1),
      valueDataSource('bya', 2),
      valueDataSource('nta', 3),
      coloredEntitiesDataSource('bta', 4),
      coloredEntitiesDataSource('bra', 5),
      coloredEntitiesDataSource('bya', 6),
      coloredEntitiesDataSource('nta', 7),
      {
        id: 'portfolio.area.heatmap',
        type: 'fetch',
        fetch: 'fetch.portfolio.area.heatmap'
      }
    ],
    informationFetch: 'fetch.portfolio.area.information'
  },
  children: [
    measurementFromName('bta', true),
    measurementFromName('bra'),
    measurementFromName('bya'),
    measurementFromName('nta'),
    {
      name: 'area-heatmap',
      enabled: true,
      component: 'CardHeatmap',
      title: {
        en: '',
        sv: ''
      },
      info: {
        en: '',
        sv: ''
      },
      props: {
        titles: {
          CONSTRUCTION: {
            sv: 'Översikt area (m²) per byggnad',
            en: 'Area overview (m²) per building'
          }
        },
        noReverse: true,
        dataSource: 'portfolio.area.heatmap',
        colorScale: createColorScale('#40A9FF', 0, 50000),
        ySumLabel: {
          en: '',
          sv: ''
        },
        tooltipLabel: {
          en: 'Area',
          sv: 'Area'
        },
        dataFormat: areaFormat,
        // timeFormat: ,
        enabledEntityLevels: ['COMPLEX', 'REAL_ESTATE'],
        errorMessages: {
          NO_DATA: {
            en: 'No data available',
            sv: 'Ingen data tillgänglig'
          },
          INVALID_FILTER: {
            en: 'Filter on complex or real estate to show data',
            sv: 'Filtrera på komplex eller fastighet för att visa data'
          }
        },
        subMeasurementToTitle: {}
      }
    }
  ]
}
